module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt20 ovh min_height"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetail == 0),
      expression: "showDetail == 0"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.hasEditContract == 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openAddContract(0)
      }
    }
  }, [_vm._v("新增合同")]) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.agreementList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "contractCode",
      "label": "合同编号",
      "width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contractName",
      "label": "合同名称",
      "min-width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryName",
      "label": "主营品类",
      "align": "center",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.categoryLevels), function(category) {
          return _c('p', [_vm._v(_vm._s(category.grandName) + "-" + _vm._s(category.parentName) + "-" + _vm._s(category.childrenName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开始时间",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("time")(scope.row.contractStartDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结束时间",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("time")(scope.row.contractEndDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "fixed": "right",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.detail(scope.row.id, 1)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), (_vm.hasEditContract == 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.openAddContract(scope.row.id)
            }
          }
        }, [_vm._v("编辑合同")]) : _vm._e(), _vm._v(" "), (_vm.hasEditContract == 1 && scope.row.applyStatus == 4) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.removeAgreement(scope.row.id)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (scope.row.hasConfirmContract == 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.detail(scope.row.id, 2)
            }
          }
        }, [_vm._v("确认证件齐全")]) : _vm._e(), _vm._v(" "), (scope.row.hasConfirmDeposit == 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.detail(scope.row.id, 2)
            }
          }
        }, [_vm._v("确认收到保证金")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.secondAuditAuth == 1) ? _c('div', {
    attrs: {
      "align": "center"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetail == 1),
      expression: "showDetail == 1"
    }],
    staticClass: "pl10 mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("合同基本信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商合同编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.contractCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.suppliersCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.suppliersName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合作方式："
    }
  }, [(_vm.agreementDetail.cooperationType == 1) ? _c('span', [_vm._v("入仓")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.cooperationType == 2) ? _c('span', [_vm._v("入仓（实销实结）")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.cooperationType == 3) ? _c('span', [_vm._v("自发货")]) : _vm._e()]), _vm._v(" "), (_vm.agreementDetail.cooperationType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "发货时效："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.deliveryTime) + "小时")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同开始时间："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.contractStartTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同结束时间："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.contractEndTime))])]), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("主营品牌信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto",
      "margin-bottom": "22px",
      "margin-top": "22px"
    },
    attrs: {
      "data": _vm.agreementDetail.applyAgreementBrandList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "brandName",
      "label": "品牌",
      "width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合作品类",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.categoryLevel.grandName) + "-" + _vm._s(scope.row.categoryLevel.parentName) + "-" + _vm._s(scope.row.categoryLevel.childrenName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否提供发票",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && scope.row.invoiceType == 1) ? _c('span', [_vm._v("增值税普通发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && scope.row.invoiceType == 3) ? _c('span', [_vm._v("形式发票")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return scope.row.rate != null && scope.row.rate != undefined ? [(scope.row.rate == null || scope.row.rate == undefined) ? _c('span') : _vm._e(), _vm._v(" "), _vm._l((scope.row.rate.split(',')), function(rateValue) {
          return (rateValue) ? _c('span', [_vm._v("\n                            " + _vm._s(rateValue) + "% \n                        ")]) : _vm._e()
        })] : undefined
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("合同条款-财务信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算主体："
    }
  }, [(_vm.agreementDetail.settlementBodyId == 1) ? _c('span', [_vm._v("北京果敢时代科技有限公司")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementBodyId == 2) ? _c('span', [_vm._v("MAMA HONG KONG")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementBodyId == 3) ? _c('span', [_vm._v("天津果敢时代国际贸易有限公司")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementBodyId == 4) ? _c('span', [_vm._v("正合奇胜（天津）企业咨询管理有限公司")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementBodyId == 5) ? _c('span', [_vm._v("老师线下打款")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式："
    }
  }, [(_vm.agreementDetail.settlementType == 1) ? _c('span', [_vm._v("直采")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementType == 2) ? _c('span', [_vm._v("预付款")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementType == 3) ? _c('span', [_vm._v("实销实结")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算币种："
    }
  }, [_vm._v("人民币")]), _vm._v(" "), (_vm.agreementDetail.settlementType != 2 && _vm.agreementDetail.settlementPaymentType == 0) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.settlementPaymentDays) + "天")])]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementType != 2 && _vm.agreementDetail.settlementPaymentType && _vm.agreementDetail.settlementPaymentType >= 2) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, [(_vm.agreementDetail.settlementPaymentType == 2) ? _c('span', [_vm._v("按年结算")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementPaymentType == 3) ? _c('span', [_vm._v("按半年结算")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementPaymentType == 4) ? _c('span', [_vm._v("按季度结算")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementPaymentType == 5) ? _c('span', [_vm._v("按月结算")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementPaymentType == 6) ? _c('span', [_vm._v("按半月结算")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, _vm._l((_vm.agreementDetail.settlementPaymentRate.split(',')), function(paymentRate, index) {
    return _c('span', [_vm._v(_vm._s(index == 0 ? "" : ",") + "第" + _vm._s(index + 1) + "期" + _vm._s(paymentRate) + "%")])
  })) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否需要保证金："
    }
  }, [(_vm.agreementDetail.shouldDeposit == 0) ? _c('span', [_vm._v("不需要")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.shouldDeposit == 1) ? _c('span', [_vm._v("需要")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "保证金："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.deposit) + "人民币")]), _vm._v(" "), (_vm.agreementDetail.hasConfirmDeposit == 1 && _vm.showView == 2) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmDeposit(_vm.agreementDetail.id)
      }
    }
  }, [_vm._v("\n                        财务确认收到保证金\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货款支付方式："
    }
  }, [_vm._v("甲方将货款直接支付到乙方的如下银行账户")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.bankName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行账号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.accountNumber))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行户名："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.accountName))])]), _vm._v(" "), (_vm.agreementDetail.registeredCountry != 1) ? _c('el-form-item', {
    attrs: {
      "label": "SwiftCode："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.swiftCode))])]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "省："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.province))])]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "市："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.city))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("线上合同信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同名称："
    }
  }, [(_vm.supplierEditContract == 1) ? _c('div', {
    staticStyle: {
      "margin-left": "0px",
      "margin-top": "20px"
    }
  }, _vm._l((_vm.agreementDetail.templateContents), function(val) {
    return _c('div', {
      staticClass: "agree_wrap"
    }, [_c('div', {
      staticClass: "in_block"
    }, [_c('span', {
      staticClass: "agree"
    }, [_vm._v(_vm._s(val.name))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.editAgree(val, _vm.agreementDetail.contractCode)
        }
      }
    }, [_vm._v("编辑")])], 1)])
  })) : _vm._e(), _vm._v(" "), (_vm.supplierEditContract == 0) ? _vm._l((_vm.agreementDetail.templateContents), function(content, index) {
    return _c('span', [_c('el-button', {
      attrs: {
        "type": "text",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.contentDetail(content)
        }
      }
    }, [_vm._v(" " + _vm._s(content.name) + " ")])], 1)
  }) : _vm._e()], 2), _vm._v(" "), (_vm.agreementDetail.hasConfirmContract == 1 && _vm.showView == 2 && _vm.agreementDetail.signContract != 1) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "纸质合同电子版："
    }
  }, [_c('span', {
    staticClass: "f666 f12"
  }, [_vm._v("请将纸质合同扫描件上传到系统")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.contractFileArr,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")])], 1) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.hasConfirmContract == 1 && _vm.showView == 2 && _vm.agreementDetail.signContract != 1) ? _c('el-form-item', [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmContract(_vm.agreementDetail.id)
      }
    }
  }, [_vm._v("\n                        法务确认证件齐全\n                    ")]), _vm._v("确认之后，系统会开通供应商入驻相关权限\n                ")], 1) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.signContract == 1) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "纸质合同电子版："
    }
  }, [_c('div', _vm._l((_vm.agreementDetail.contractFileArr), function(contractFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": contractFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w60 auto mtb20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reback()
      }
    }
  }, [_vm._v("返回合同协议列表")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible2,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl2,
      "alt": ""
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d7bcd8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierapply/audit/agreementList.vue
// module id = 507
// module chunks = 0